import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/components/auth/AuthContext";
import { supabase } from "@/lib/supabase";
import { Bot, BarChart2 } from "lucide-react";
import { ChangePasswordModal } from "@/components/auth/ChangePasswordModal";

const DEFAULT_AI_CHAT_SETTINGS = {
  enabled: false,
  allowed_roles: ["admin"],
};

export function Header() {
  const { user, logout } = useAuth();
  const [title, setTitle] = useState("Sistema de Gestión de Moda");
  const [showBot, setShowBot] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);

  const loadSettings = async () => {
    try {
      const { data, error } = await supabase
        .from("app_settings")
        .select("title, ai_chat_settings")
        .limit(50);

      if (error) throw error;
      
      if (data && data.length > 0) {
        const settingsRowWithTitle = data.find((row) => row.title) || data[0];
        const settingsRowWithChat = data.find((row) => row.ai_chat_settings) || settingsRowWithTitle;
        const nextTitle = settingsRowWithTitle?.title || "Sistema de Gestión de Moda";
        const aiChatSettings = {
          ...DEFAULT_AI_CHAT_SETTINGS,
          ...(settingsRowWithChat?.ai_chat_settings || {}),
        };

        setTitle(nextTitle);
        document.title = nextTitle;

        const allowedRoles = Array.isArray(aiChatSettings.allowed_roles)
          ? aiChatSettings.allowed_roles
          : DEFAULT_AI_CHAT_SETTINGS.allowed_roles;

        setShowBot(Boolean(user && aiChatSettings.enabled && allowedRoles.includes(user.role)));
      } else {
        setShowBot(false);
      }
    } catch (error) {
      console.error('Error loading settings:', error);
      setShowBot(false);
    }
  };

  useEffect(() => {
    loadSettings();
  }, [user]);

  return (
    <header className="header-gradient shadow-lg">
      <div className="container mx-auto p-4 flex justify-between items-center">
        <h1 className="text-2xl font-bold text-white">{title}</h1>
        {user && (
          <div className="flex items-center gap-4">
            {showBot && (
              <Button
                variant="default"
                size="icon"
                onClick={() => window.location.hash = "#/chat"}
                className="bg-white text-gray-900 hover:bg-gray-100"
              >
                <Bot className="h-5 w-5" />
              </Button>
            )}
            <Button
              variant="default"
              onClick={() => window.location.hash = "#/informes"}
              className="bg-white text-gray-900 hover:bg-gray-100"
            >
              <BarChart2 className="h-5 w-5 mr-2" />
              Informes
            </Button>
            <span className="text-sm text-white">
              {user.name} ({user.role})
            </span>
            <Button
              variant="default"
              onClick={() => setShowChangePassword(true)}
              className="bg-white text-gray-900 hover:bg-gray-100"
            >
              Cambiar contraseña
            </Button>
            <Button 
              variant="default" 
              onClick={logout}
              className="bg-white text-gray-900 hover:bg-gray-100"
            >
              Cerrar Sesión
            </Button>
            <ChangePasswordModal open={showChangePassword} onClose={() => setShowChangePassword(false)} userEmail={user.username} />
          </div>
        )}
      </div>
    </header>
  );
}
